export default __webpack_public_path__ + "static/media/25t.6192325c.jpg";